export default __webpack_public_path__ + "static/media/inyek_ico.e0e7030a.png";